import Routes from './routes';

import Header from './components/header/Header';
import Nav from './components/nav/Nav';
import useGlobalRedirect from './utils/hooks/useGlobalRedirect';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advancedFormat);

const App: React.FC = () => {
    useGlobalRedirect();
    const darkMode = false;

    return (
        <div id="admin-body" className={`body ${darkMode ? 'dark-mode' : ''} `}>
            <Header />
            <div id="admin-wrapper">
                <Nav />
                <div id="admin-content" className="custom-scroll">
                    <Routes />
                </div>
            </div>
        </div>
    );
};

export default App;
